
















































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Family } from '@/interfaces/Models';
import axios from 'axios';
import { api } from '@/api';
import LanguagePicker from '@/components/dashboard/shared/components/LanguagePicker.vue';
import { State, Getter, Action, Mutation } from 'vuex-class';
import { Debounce } from 'lodash-decorators';

@Component({
  components: {
    LanguagePicker,
  },
})
export default class FamilyProfile extends Vue {
  public family!: Family;

  @Prop()
  id!: number;

  public menu: boolean = false;

  public family_name: string = '';
  public primaryParent: number | null = null;
  public babysittingLanguage: number | null = null;
  public contact: string = '';
  public additionalInfo: string | null = null;

  public address_id: any = null;

  public address: any = {
    address: '',
    area_name: '',
    city: '',
    city_id: null,
    district: '',
    postal_code: '',
    geo_location: '',
  };

  public familyPets: any = [];

  public children: any = [];

  public parents: any = [];

  public preferredBabysitterName: string = '';
  public blockedBabysitterName: string = '';
  public babysitters: any = [];
  public babysittersLoading: boolean = false;

  public preferredBabysitters: any = [];
  public blockedBabysitters: any = [];

  public babysittingPreferences: any = {
    female_sitter: false,
    male_sitter: false,
    sitter_smoking: false,
    driver_with_car: false,
    driver_without_car: false,
  };

  public contactPreferences: any = {
    sms: false,
    email: false,
    whatsapp: false,
    call: false,
  };

  public dataLoading: boolean = true;

  public get genders(): any[] {
    return [
      {
        text: this.$t('genders.0'),
        value: 0,
      },
      {
        text: this.$t('genders.1'),
        value: 1,
      },
    ];
  }

  public nationalities: any = [];
  public pets: any = [];

  public get tabs(): any[] {
    return [
      {
        text: this.$t('families.edit.family.title'),
        icon: 'mdi-home',
      },
      {
        text: this.$t('families.edit.children.title'),
        icon: 'mdi-account-child',
      },
      {
        text: this.$t('families.edit.parents.title'),
        icon: 'mdi-human-male-female',
      },
      {
        text: 'sitters',
        icon: 'mdi-human-baby-changing-table',
      },
      {
        text: 'preferences',
        icon: 'mdi-tune',
      },
    ];
  }

  public saveFamily() {
    this.dataLoading = true;

    let payload = {
      family_name: this.family_name,
      primary_parent_id: this.primaryParent,
      babysitting_language_id: this.babysittingLanguage,
      contact: this.contact,
      additional_info: this.additionalInfo,
      address: this.address,
      pets: this.familyPets,
    };

    axios
      .put(
        api.path('v1.admin.families.single', { id: this.family.id }),
        payload,
      )
      .then((res) => this.$toast.success(res.data.message))
      .finally(() => (this.dataLoading = false));
  }

  public getChildrenPayload() {
    return this.children.map((child: any) => {
      child.languages = {
        ...child.selectedLanguages,
      };
      return child;
    });
  }

  public saveChildren() {
    this.dataLoading = true;

    let childrenPayload = this.getChildrenPayload();

    axios
      .put(
        api.path('v1.admin.families.updateChildren', { id: this.family.id }),
        { children: childrenPayload },
      )
      .then(async (res) => {
        this.$toast.success(res.data.message);
        await this.loadFamily();
      })
      .finally(() => (this.dataLoading = false));
  }

  public getParentsPayload() {
    return this.parents.map((parent: any) => {
      parent.languages = {
        ...parent.selectedLanguages,
      };
      return parent;
    });
  }

  public async saveParents() {
    this.dataLoading = true;

    let parentsPayload = this.getParentsPayload();

    await axios
      .put(
        api.path('v1.admin.families.updateParents', { id: this.family.id }),
        { parents: parentsPayload },
      )
      .then(async (res) => {
        this.$toast.success(res.data.message);
        await this.loadFamily();
      })
      .finally(() => (this.dataLoading = false));
  }

  public async savePreferredBabysitters() {
    this.dataLoading = true;

    let payload = this.getBabysittersPayload();

    await axios
      .put(
        api.path('v1.admin.families.updatePreferredBabysitters', {
          id: this.family.id,
        }),
        { preferredBabysitters: payload },
      )
      .then(async (res) => {
        this.$toast.success(res.data.message);
      })
      .finally(() => (this.dataLoading = false));
  }

  public async saveBlockedBabysitters() {
    this.dataLoading = true;

    let payload = this.blockedBabysitters.map(
      (babysitter: any) => babysitter.id,
    );

    await axios
      .put(
        api.path('v1.admin.families.updateBlockedBabysitters', {
          id: this.family.id,
        }),
        { babysitters: payload },
      )
      .then(async (res) => {
        this.$toast.success(res.data.message);
      })
      .finally(() => (this.dataLoading = false));
  }

  public async savePreferences() {
    this.dataLoading = true;

    let payload = {
      babysittingPreferences: {
        female_sitter: this.babysittingPreferences.female_sitter ? 1 : 0,
        male_sitter: this.babysittingPreferences.male_sitter ? 1 : 0,
        sitter_smoking: this.babysittingPreferences.sitter_smoking ? 1 : 0,
        driver_with_car: this.babysittingPreferences.driver_with_car ? 1 : 0,
        driver_without_car: this.babysittingPreferences.driver_without_car
          ? 1
          : 0,
      },
      contactPreferences: {
        sms: this.contactPreferences.sms ? 1 : 0,
        email: this.contactPreferences.email ? 1 : 0,
        whatsapp: this.contactPreferences.whatsapp ? 1 : 0,
        call: this.contactPreferences.call ? 1 : 0,
      },
    };
    try {
      await axios.put(
        api.path('v1.admin.families.babysittingPreferences', {
          id: this.family.id,
        }),
        payload['babysittingPreferences'],
      );
      await axios.put(
        api.path('v1.admin.families.contactPreferences', {
          id: this.family.id,
        }),
        payload['contactPreferences'],
      );

      this.$toast.success('Preferences saved successfully');
    } catch (e) {
      this.$toast.error('Error saving preferences');
    } finally {
      this.dataLoading = false;
    }
  }

  public test(arg: any) {
    console.log(arg);
  }

  public getBabysittersPayload() {
    return this.preferredBabysitters.map((babysitter: any) => babysitter.id);
  }

  public addChild() {
    this.children.push({
      id: null,
      first_name: '',
      gender: null,
      date_of_birth: '',
      address_id: null,
      address_name: '',
      area_name: '',
      city: '',
      languages: [],
      note: '',
      menu: false,
    });
  }

  public addParent() {
    this.parents.push({
      id: null,
      first_name: '',
      last_name: '',
      contact: '',
      email: '',
      nationality_id: null,
      languages: [],
    });
  }

  public removeChild(index: any) {
    this.children = this.children.filter(
      (child: any, cIndex: any) => cIndex !== index,
    );
  }

  public removeParent(index: any) {
    this.parents = this.parents.filter(
      (parents: any, pIndex: any) => pIndex !== index,
    );
  }

  public async loadNationalities() {
    let params = {
      paginate: 'no',
    };

    await axios
      .get(api.path('v1.admin.nationalities'), { params: params })
      .then((res) => (this.nationalities = res.data.data));
  }

  public async loadPets() {
    let params = {
      paginate: 'no',
    };

    await axios
      .get(api.path('v1.admin.pets'), { params: params })
      .then((res) => (this.pets = res.data.data));
  }

  public $refs!: {
    picker: any;
  };

  @Watch('children', { deep: true })
  onChange(value: any, old: any) {
    value.forEach((element: any, i: any) => {
      if (element.menu) {
        element.menu &&
          setTimeout(() => (this.$refs.picker[i].activePicker = 'YEAR'));
      }
    });
  }

  public async loadFamily(): Promise<void> {
    let res = await axios.get(
      api.path('v1.admin.families.edit', { id: this.id }),
    );

    this.family = res.data.data;
    this.setFamily(res.data.data);
  }

  public setFamily(family: Family) {
    this.family_name = family.family_name;
    this.contact = family.contact;
    this.primaryParent = family.parent?.id;
    this.babysittingLanguage = family.babysittingLanguage?.id;
    this.additionalInfo = family.additional_info;

    this.address = family.address;

    this.familyPets = family.pets?.map((pet) => pet.id);

    this.children = family.children?.map((child) => {
      child.menu = false;

      child.address_name = child.address ? child.address.address : '';
      child.city =
        child.address && child.address.city ? child.address.city.name : '';
      child.area_name =
        child.address && child.address.area_name ? child.address.area_name : '';
      child.address_id = child.address ? child.address.id : null;

      child.selectedLanguages = [];

      if (child.nativeLanguage) {
        child.languages.push(child.nativeLanguage);
      }

      if (child.languages.length > 0) {
        child.languages.forEach((lang: any) =>
          this.$set(child.selectedLanguages, lang.id, {
            language_level: lang.level?.id,
          }),
        );
      }

      return child;
    });

    this.parents = family.parents?.map((parent) => {
      parent.first_name = parent.first_name ?? '';
      parent.last_name = parent.last_name ?? '';
      parent.contact = parent.contact ?? '';
      parent.email = parent.email ?? '';

      parent.selectedLanguages = [];

      if (parent.nativeLanguage) {
        parent.languages.push(parent.nativeLanguage);
      }

      if (parent.languages.length > 0) {
        parent.languages.forEach((lang: any) =>
          this.$set(parent.selectedLanguages, lang.id, {
            language_level: lang.level?.id,
          }),
        );
      }

      return parent;
    });

    this.preferredBabysitters = family.preferredBabysitters;
    this.blockedBabysitters = family.blockedBabysitters;

    this.babysittingPreferences = {
      female_sitter: family?.babysittingPreferences?.female_sitter === 1,
      male_sitter: family?.babysittingPreferences?.male_sitter === 1,
      sitter_smoking: family?.babysittingPreferences?.sitter_smoking === 1,
      driver_with_car: family?.babysittingPreferences?.driver_with_car === 1,
      driver_without_car:
        family?.babysittingPreferences?.driver_without_car === 1,
    };

    this.contactPreferences = {
      sms: family?.user?.contact_preferences?.sms === 1,
      email: family?.user?.contact_preferences?.email === 1,
      whatsapp: family?.user?.contact_preferences?.whatsapp === 1,
      call: family?.user?.contact_preferences?.call === 1,
    };
  }

  @Action('languages/fetchLanguages') fetchLanguages: any;
  @Getter('languages/languages') languages: any;

  @Action('cities/fetchCities') fetchCities: any;
  @Getter('cities/cities') cities: any;

  @Watch('preferredBabysitterName')
  @Watch('blockedBabysitterName')
  @Debounce(500)
  onBabysitterNameChange(value: string): void {
    this.babysittersLoading = true;
    let params = {
      paginate: 'no',
      name: value,
    };

    axios
      .get(api.path('v1.admin.babysitters'), { params: params })
      .then((res) => {
        this.babysitters = res.data.data;
      })
      .finally(() => (this.babysittersLoading = false));
  }

  public async mounted() {
    await this.fetchCities();
    await this.fetchLanguages();
    await this.loadNationalities();
    await this.loadPets();

    await this.loadFamily();

    this.dataLoading = false;
  }
}
